import { DataTable } from './table.types';      
import { TableData } from './tableData.types';   
import { User } from './auth.types';  
export enum TransferStatus {
    PENDING = 'pending',
    COMPLETED = 'completed',
    REJECTED = 'rejected',
    CANCELLED = 'cancelled',
  }
  
  export interface TransferItem {
    id: string;
    transferId: string;
    sourceTableId: string;
    sourceDataId: string;
    targetTableId?: string;
    targetDataId?: string;
    sourceTable?: DataTable;
    sourceData?: TableData;
    targetTable?: DataTable;
    targetData?: TableData;
    createdAt: string;
  }
  
  export interface DataTransfer {
    id: string;
    description?: string;
    status: TransferStatus;
    sourceUserId: string;
    targetUserId: string;
    sourceUser?: User;
    targetUser?: User;
    items: TransferItem[];
    createdAt: string;
    updatedAt: string;
  }
  
  export interface CreateTransferItemRequest {
    sourceTableId: string;
    sourceDataId: string;
    targetTableId?: string;
  }
  
  export interface CreateTransferRequest {
    targetUserId: string;
    description?: string;
    items: CreateTransferItemRequest[];
  }
  
  export interface UpdateTransferStatusRequest {
    status: TransferStatus;
  }